//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import FormatListNumberedRtlOutlinedIcon from '@mui/icons-material/FormatListNumberedRtlOutlined';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'tipoFruta_Id';

export default function TiposFruta_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'nombre',
            headerName: intl.formatMessage({ id: 'Nombre' }),
            editable: false,
            flex: 0.5,
        },
        {
            field: 'producto',
            headerName: intl.formatMessage({ id: 'Producto' }),
            editable: false,
            flex: 0.5,
        },
        //{
        //    field: 'calibres',
        //    headerName: '',
        //    sortable: false,
        //    editable: false,
        //    filterable: false,
        //    align: 'center',
        //    width: 100,
        //    renderCell: (params) => {
        //        return (
        //            <Button onClick={() => {
        //                navigate('/TiposFruta/' + params.row[keyField] + '/Calibres');
        //            }}>
        //                {intl.formatMessage({ id: 'Calibres' })}
        //            </Button>
        //        )
        //    },
        //},
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 180,
            renderCell: (params) => {
                let disabled = params.row["etiquetasCore"] > 0 || params.row["calibres"] > 0;
                return (
                    <div>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Calibres" })}>
                            <IconButton className="DarkTealButton GridButton" onClick={() => {
                                navigate('/TiposFruta/' + params.row[keyField] + '/Calibres');
                            }}>
                                <FormatListNumberedRtlOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                            <IconButton className='DarkBlueButton GridButton' onClick={() => {
                                props.edit_onclick(params.row[keyField])
                            }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        {disabled ?
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Existen elementos asociados a este item" })}>
                                <span>
                                    <IconButton disabled={disabled} className='DisabledButton GridButton'>
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip> :
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Eliminar" })}>
                                <IconButton disabled={disabled} className='RedButton GridButton' onClick={() => {
                                    props.delete_onclick(params.row[keyField])
                                }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>}
                    </div>

                )
            },
        },
    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        tipoFruta_Id: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">
                        
                    </div>
                </div>
                <Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {
                    props.add_onclick()
                }}><AddIcon /> Agregar</Button>


            </Toolbar>
            <Box sx={{
                height: 600, width: 1000,
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
